import React from 'react'
// import Hero from '../components/Hero'
import Rate from '../components/Rate'
import Solution from '../components/Solution'
import Convert from '../components/Convert'
import Footer from '../components/Footer'
import HomeMain from '../components/HomeMain'


export default function Home() {
  return (
    <>
    <HomeMain/>
    <Rate/>
    <Solution/>
    <Convert/>
    <Footer/>
    </>
  )
}
